import { OPENING_MODE_VALUES, type OpeningConfigLine, type OpeningMode } from '@gozoki/api-types';
import { Box, Typography } from '@mui/material';

import { DateTime } from 'luxon';
import { fonts } from '../../utils/theme/fonts.theme';
import { HourConfigCard } from './HourConfigCard';

export const DayConfigCard = ({
    day,
    openingConfigs,
    onConfigChange,
}: {
    day: string;
    openingConfigs: OpeningConfigLine[];
    onConfigChange: (configCards: OpeningConfigLine[]) => void;
}) => {
    const handleAdd = () => {
        const newOpeningConfigCards = [
            ...openingConfigs,
            {
                openingMode: OPENING_MODE_VALUES[0],
                beginTime:
                    openingConfigs[openingConfigs.length - 1]?.endTime || DateTime.now().toString(),
                endTime:
                    openingConfigs[openingConfigs.length - 1]?.endTime || DateTime.now().toString(),
            },
        ];
        onConfigChange(newOpeningConfigCards);
    };

    const handleDelete = (index: number) => {
        const updatedCards = openingConfigs.filter((_, idx) => idx !== index);
        onConfigChange(updatedCards);
    };

    const handleModify = (
        index: number,
        openingMode: OpeningMode,
        beginTime: DateTime,
        endTime: DateTime
    ) => {
        const updatedCards = openingConfigs.map((item, idx) =>
            idx === index
                ? {
                      ...item,
                      openingMode,
                      beginTime: beginTime.toString(),
                      endTime: endTime.toString(),
                  }
                : item
        );
        onConfigChange(updatedCards);
    };

    return (
        <Box>
            <Typography style={fonts.tabTitle} flexGrow={1}>
                {day}
            </Typography>
            {openingConfigs.map((oc, index) => (
                <HourConfigCard
                    key={`${index}-${oc.openingMode}`}
                    isAddButton={index === 0}
                    buttonClick={index === 0 ? handleAdd : () => handleDelete(index)}
                    openingConfigCard={oc}
                    modify={(openingMode: OpeningMode, beginTime: DateTime, endTime: DateTime) => {
                        handleModify(index, openingMode, beginTime, endTime);
                    }}
                />
            ))}
        </Box>
    );
};
